import { useCallback } from 'react';

import PostDropBoxUpload from '../services/adapters/dropBoxUpload';
import usePresignedFileUpload, { PresignedUploadResult } from './usePresignedFileUpload';

export default function useDropBoxFileUpload(onComplete?: () => void) {
  const getPresignedUrl = useCallback(async (fileName: string, file: File): Promise<PresignedUploadResult> => {
    // Lowercased to match the value the backend normalises and signs
    const contentType = file.type.toLowerCase();
    const adapter = new PostDropBoxUpload();
    const { presignedUrl, uploadedBy, fileName: signedFileName } = await adapter.adaptResponse({
      fileName,
      contentType,
    });

    // The content type and metadata headers are part of the presigned URL
    // signature, so they must exactly match the values the backend signed
    const headers: Record<string, string> = {};
    headers['Content-Type'] = contentType;
    if (uploadedBy) {
      headers['x-amz-meta-uploaded-by'] = uploadedBy;
    }
    if (signedFileName) {
      headers['x-amz-meta-file-name'] = signedFileName;
    }

    return { url: presignedUrl, headers, meta: undefined };
  }, []);

  return usePresignedFileUpload(getPresignedUrl, onComplete);
}
